import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '@alltrails/modal/components/Modal/Modal';
import ModalStep from '@alltrails/modal/components/Modal/ModalStep';
import FiltersModalContentV2 from '../../FiltersModalContentV2/FiltersModalContentV2';

type FiltersModalV2Props = Pick<ComponentProps<typeof Modal>, 'onCloseRequest'> & {
  sections: ComponentProps<typeof FiltersModalContentV2>['sections'];
  onClear?: () => void;
  onSeeTrailsClick?: () => void;
  trailResultCount: number | null; // null indicates loading
};

const FiltersModalV2 = ({ onCloseRequest, sections, onClear, onSeeTrailsClick, trailResultCount }: FiltersModalV2Props) => {
  const onPrimaryClick = () => {
    onSeeTrailsClick?.();
    onCloseRequest();
  };

  return (
    <ModalStep
      buttons={{
        primaryButton: {
          loading: trailResultCount === null,
          onClick: onPrimaryClick,
          text: (
            <FormattedMessage defaultMessage="Show {count} {count, plural, one {trail} other {trails}}" values={{ count: trailResultCount ?? 0 }} />
          )
        },
        ...(onClear
          ? {
              flatButton: {
                onClick: onClear,
                text: <FormattedMessage defaultMessage="Clear" />
              }
            }
          : {})
      }}
      onCloseRequest={onCloseRequest}
      title={<FormattedMessage defaultMessage="Filters" />}
    >
      <FiltersModalContentV2 sections={sections} />
    </ModalStep>
  );
};

export default FiltersModalV2;
